import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../../../environments/environment';
import { Constants } from '../../../../../core/services/constants.service';
import { Router } from '@angular/router';
import { HttpService } from '../../../../../core';

@Component({
  selector: 'app-lot-detail-dialog',
  templateUrl: './lot-detail-dialog.component.html',
  styleUrls: ['./lot-detail-dialog.component.scss']
})
export class LotDetailDialogComponent implements OnInit {

  lot: any;
  project: any;
  building: any;
  imageUrl: any;
  SERVER_URL = environment.SERVER_URL;
  packages = [];
  existingPackages = [];
  properties = [];

  editProperty = new EventEmitter()

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.lot = this.data.lot;
    this.building = this.data.building;
    this.project = this.data.project;
    this.httpService.getPackageByLot(this.lot.id).subscribe((res: any) => {
      this.packages = res.data;
      this.properties = [].concat(...this.packages.map(p => p.properties));
    });
  }

  getImageUlr(fileName) {
    return this.SERVER_URL + 'images/' + this.project.projectCode + '/floor_plans/' + fileName;
  }

  cancel() {
    this.dialogRef.close();
  }

  editPropertyClick(property) {
    this.cancel();
    this.editProperty.emit({ property: property });
  }

  editLot() {
    this.cancel();
    this.router.navigate(
      ['/projects/' + this.project.id + '/edit-lot/' + this.lot.id],
      {
        queryParams: { projectCode: this.project.projectCode, projectName: this.project.name, projectId: this.project.id },
        state: { project: this.project }
      }
    ).then();
  }

  getStatusLabel(status) {
    switch (status) {
      case 0:
        return 'unavailable';
      case 1:
        return 'available';
      case 2:
        return 'reserved'; // eoi
      case 3:
        return 'reserved';
      case 4:
        return 'processing';  //exchanage conditional
      case 5:
        return 'processing'; // unconditional
      case 6:
        return 'sold';
    }
  }
}
